/* Filo Finds — theme.js
   Cart drawer (open/close, AJAX add-to-cart, line removal),
   mobile nav, product image gallery + zoom modal. */

(() => {
  "use strict";
  const $  = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  // -------- Cart drawer ----------------------------------------------------
  const drawer = $("[data-cart-drawer]");
  function openCart()  { if (drawer) { drawer.hidden = false; requestAnimationFrame(() => drawer.setAttribute("aria-hidden", "false")); document.body.style.overflow = "hidden"; } }
  function closeCart() { if (drawer) { drawer.setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; setTimeout(() => drawer.hidden = true, 280); } }

  $$("[data-cart-drawer-toggle]").forEach(el => el.addEventListener("click", openCart));
  $$("[data-cart-drawer-close]").forEach(el => el.addEventListener("click", closeCart));
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeCart(); });

  async function refreshCartUI() {
    const res = await fetch("/cart.js");
    const cart = await res.json();
    const countEl = $("[data-cart-count]");
    if (countEl) { countEl.textContent = cart.item_count; countEl.setAttribute("data-cart-count", cart.item_count); }
    // Re-render drawer body via /?section_id=cart-drawer is the proper Shopify pattern.
    // Falls back to a soft re-render here:
    const section = await fetch("/?section_id=cart-drawer").then(r => r.text()).catch(() => "");
    if (section) {
      const parsed = new DOMParser().parseFromString(section, "text/html");
      const newBody = parsed.querySelector("[data-cart-drawer-body]");
      const newFoot = parsed.querySelector("[data-cart-drawer-foot]");
      if (newBody) $("[data-cart-drawer-body]").innerHTML = newBody.innerHTML;
      if (newFoot) {
        $("[data-cart-drawer-foot]").innerHTML = newFoot.innerHTML;
        $("[data-cart-drawer-foot]").hidden = cart.item_count === 0;
      }
      bindCartLineRemovers();
    }
  }

  function bindCartLineRemovers() {
    $$("[data-cart-remove]").forEach(btn => {
      btn.addEventListener("click", async () => {
        const key = btn.dataset.cartRemove;
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: key, quantity: 0 }),
        });
        await refreshCartUI();
      });
    });
  }
  bindCartLineRemovers();

  // -------- Cart page quantity +/- buttons ---------------------------------
  function bindCartPageQty() {
    $$("[data-cart-qty-minus]").forEach(btn => {
      btn.addEventListener("click", () => {
        const input = btn.closest(".qty-selector").querySelector("[data-cart-qty-input]");
        if (input && input.value > 0) { input.value = parseInt(input.value, 10) - 1; updateCartLine(input); }
      });
    });
    $$("[data-cart-qty-plus]").forEach(btn => {
      btn.addEventListener("click", () => {
        const input = btn.closest(".qty-selector").querySelector("[data-cart-qty-input]");
        if (input) { input.value = parseInt(input.value, 10) + 1; updateCartLine(input); }
      });
    });
    $$("[data-cart-qty-input]").forEach(input => {
      input.addEventListener("change", () => updateCartLine(input));
    });
  }
  async function updateCartLine(input) {
    const key = input.dataset.key;
    const qty = Math.max(0, parseInt(input.value, 10) || 0);
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    location.reload();
  }
  bindCartPageQty();

  // AJAX product add-to-cart
  $$("form[action$='/cart/add']").forEach(form => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const btn = form.querySelector("[data-add-to-cart]");
      if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent; btn.textContent = "Adding…"; }
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Accept": "application/json" },
          body: new FormData(form),
        });
        if (!res.ok) throw new Error(await res.text());
        await refreshCartUI();
        openCart();
      } catch (err) {
        console.error("add to cart failed", err);
        alert("Could not add to cart. Please try again.");
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalText || "Add to cart"; }
      }
    });
  });

  // -------- Mobile nav -----------------------------------------------------
  const mobileToggle = $("[data-mobile-nav-toggle]");
  const mobileNav = $("[data-mobile-nav]");
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener("click", () => {
      mobileNav.hidden = !mobileNav.hidden;
      mobileToggle.setAttribute("aria-expanded", String(!mobileNav.hidden));
    });
  }

  // -------- Mega-menu (desktop hover + click) ------------------------------
  const megaTrigger = $("[data-mega-trigger]");
  const megaPanel = $("[data-mega-panel]");
  if (megaTrigger && megaPanel) {
    const btn = megaTrigger.querySelector("button");
    let hoverTimer = null;
    const HOVER_DELAY = 120;    // ms before opening
    const LEAVE_DELAY = 250;    // ms grace before closing

    function openMega() {
      clearTimeout(hoverTimer);
      megaPanel.hidden = false;
      if (btn) btn.setAttribute("aria-expanded", "true");
    }
    function closeMega() {
      megaPanel.hidden = true;
      if (btn) btn.setAttribute("aria-expanded", "false");
    }
    function scheduleOpen() {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(openMega, HOVER_DELAY);
    }
    function scheduleClose() {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(closeMega, LEAVE_DELAY);
    }

    // Hover on the trigger li
    megaTrigger.addEventListener("mouseenter", scheduleOpen);
    megaTrigger.addEventListener("mouseleave", scheduleClose);

    // Hover on the panel itself keeps it open
    megaPanel.addEventListener("mouseenter", () => clearTimeout(hoverTimer));
    megaPanel.addEventListener("mouseleave", scheduleClose);

    // Click toggle (for touch / a11y)
    if (btn) {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        megaPanel.hidden ? openMega() : closeMega();
      });
    }

    // Escape key closes
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !megaPanel.hidden) {
        closeMega();
        if (btn) btn.focus();
      }
    });

    // Click outside closes
    document.addEventListener("click", (e) => {
      if (!megaPanel.hidden && !megaTrigger.contains(e.target) && !megaPanel.contains(e.target)) {
        closeMega();
      }
    });
  }

  // -------- Mobile sub-nav accordion ----------------------------------------
  $$("[data-mobile-accordion]").forEach(parent => {
    const toggleBtn = parent.querySelector(".mobile-nav__toggle");
    const subMenu = parent.querySelector(".mobile-nav__sub");
    if (!toggleBtn || !subMenu) return;
    toggleBtn.addEventListener("click", () => {
      const open = subMenu.hidden;
      subMenu.hidden = !open;
      toggleBtn.setAttribute("aria-expanded", String(open));
    });
  });

  // -------- Product gallery + zoom modal ----------------------------------
  const mainImageEl = $(".product__main-image img");
  const zoomTrigger = $("[data-zoom-trigger]");
  const zoomModal = $("[data-zoom-modal]");
  const zoomImage = $("[data-zoom-image]");
  const zoomClose = $("[data-zoom-close]");

  const thumbBtns = $$("[data-thumb]");

  function setActiveThumb(activeBtn) {
    thumbBtns.forEach(b => b.setAttribute("aria-current", "false"));
    activeBtn.setAttribute("aria-current", "true");
  }

  // Mark first thumb active on load
  if (thumbBtns.length) setActiveThumb(thumbBtns[0]);

  thumbBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      const src = btn.dataset.src;
      if (mainImageEl && src) {
        mainImageEl.src = src;
        mainImageEl.removeAttribute("srcset");
        mainImageEl.removeAttribute("sizes");
      }
      setActiveThumb(btn);
    });
  });

  function openZoom() {
    if (!zoomModal || !mainImageEl) return;
    zoomImage.src = mainImageEl.currentSrc || mainImageEl.src;
    zoomModal.hidden = false;
    document.body.style.overflow = "hidden";
  }
  function closeZoom() {
    if (!zoomModal) return;
    zoomModal.hidden = true;
    document.body.style.overflow = "";
  }
  if (zoomTrigger) zoomTrigger.addEventListener("click", openZoom);
  if (zoomClose)   zoomClose.addEventListener("click", closeZoom);
  if (zoomModal)   zoomModal.addEventListener("click", e => { if (e.target === zoomModal) closeZoom(); });
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeZoom(); });

  // -------- Recently viewed (Phase 5 — initialized here so it's available everywhere)
  try {
    const productEl = $("[data-product-id]");
    if (productEl && productEl.dataset.productId) {
      const id = productEl.dataset.productId;
      const KEY = "ff_recently_viewed";
      let list = JSON.parse(localStorage.getItem(KEY) || "[]");
      list = [id, ...list.filter(x => x !== id)].slice(0, 12);
      localStorage.setItem(KEY, JSON.stringify(list));
    }
  } catch { /* localStorage blocked — ignore */ }

  // -------- Facet sidebar toggle -------------------------------------------
  const facetSidebar  = $("#facets-sidebar");
  const facetScrim    = $("[data-facet-scrim]");

  function openFacets() {
    if (!facetSidebar) return;
    facetSidebar.classList.add("is-open");
    if (facetScrim) facetScrim.classList.add("is-visible");
    $$("[data-facet-toggle]").forEach(btn => btn.setAttribute("aria-expanded", "true"));
    document.body.style.overflow = "hidden";
  }
  function closeFacets() {
    if (!facetSidebar) return;
    facetSidebar.classList.remove("is-open");
    if (facetScrim) facetScrim.classList.remove("is-visible");
    $$("[data-facet-toggle]").forEach(btn => btn.setAttribute("aria-expanded", "false"));
    document.body.style.overflow = "";
  }

  $$("[data-facet-toggle]").forEach(btn => btn.addEventListener("click", openFacets));
  $$("[data-facet-close]").forEach(btn  => btn.addEventListener("click", closeFacets));
  if (facetScrim) facetScrim.addEventListener("click", closeFacets);
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeFacets(); });
})();
